import axios from 'axios';

export const sendMessageAPI = async( API, formData ) => {
    try {
        const sendRequest = await axios.post(`${process.env.REACT_APP_API_URL}/${API}`, formData);
        console.log(sendRequest.data);
        return formData.sendTo;
    } catch (error) {
        console.error(error)
        if(error?.response){
            alert('Error', error?.response?.data?.message);
        }else{
            alert('Error, something went wrong');
        }
        return false;
    }
}